import { api } from '@/fsd/shared/api';
import type { IApiPaginatedResponse } from '@/fsd/shared/api/types';
import type { ICounterParty } from '../../model/types/ICounterParty';
import type { GetCounterpartiesListParams } from '../../model/types/CounterpartyListParams';

export type IGetCounterPartiesListResult = IApiPaginatedResponse<{
  items: ICounterParty[];
  counterparty_types: Record<string, string>;
  status_choices: Record<string, string>;
  visibility_choices: Record<string, string>;
}>;

export const getCounterPartiesList = async (
  params: GetCounterpartiesListParams = {}
) => {
  const { page, limit, sorted, filters, with_balance, preset_id, paginator } = params;
  const body = {
    ...(page !== undefined ? { page } : {}),
    ...(limit !== undefined ? { limit } : {}),
    ...(sorted !== undefined ? { sorted } : {}),
    ...(filters !== undefined ? { filters } : {}),
    ...(with_balance !== undefined ? { with_balance } : {}),
    ...(preset_id !== undefined ? { preset_id } : {}),
    ...(paginator !== undefined ? { paginator } : {}),
  };

  const response = await api.post<IGetCounterPartiesListResult>(
    '/api/v1/general/user/counterparty/list/',
    { body }
  );

  console.log(response.data.items);

  return {
    data: response.data.items,
    message: response.message,
    meta: response.meta,
    types: response.data.counterparty_types,
    statusChoices: response.data.status_choices,
    visibilityChoices: response.data.visibility_choices,
  };
};
